import React from 'react';
import './Skills.css';

const Skills = () => {
  const skills = [
    {
      name: 'Mobil_Uygulama_Geliştirme',
      level: 'BAŞLANGIÇ_SEVİYE',
      code: 'MOB_DEV',
      percentage: 30,
      color: 'var(--neon-green)'
    },
    {
      name: 'Siber_Güvenlik',
      level: 'BAŞLANGIÇ_SEVİYE',
      code: 'CYBER_SEC',
      percentage: 30,
      color: 'var(--electric-blue)'
    }
  ];

  return (
    <section className="skills-section">
      <div className="skills-container">
        <div className="section-header">
          <span className="section-number">[03]</span>
          <h2 className="section-title">
            <span className="glitch" data-text="SKILL_TREE">SKILL_TREE</span>
          </h2>
        </div>

        <div className="skills-layout">
          {skills.map((skill, index) => (
            <div key={index} className="skill-hexagon" style={{ animationDelay: `${index * 0.2}s` }}>
              <div className="hexagon-shape">
                <div className="hex-inner">
                  <div className="hex-content">
                    <div className="skill-code">{skill.code}</div>
                    <div className="skill-percentage">{skill.percentage}%</div>
                  </div>
                </div>
              </div>
              
              <div className="skill-info">
                <h3 className="skill-name">{skill.name}</h3>
                <p className="skill-level">{skill.level}</p>
                
                <div className="skill-progress">
                  <div className="progress-track">
                    {[...Array(10)].map((_, i) => (
                      <div 
                        key={i} 
                        className={`progress-segment ${i < skill.percentage / 10 ? 'active' : ''}`}
                        style={{ 
                          animationDelay: `${i * 0.1}s`,
                          '--segment-color': skill.color
                        }}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="skills-footer">
          <div className="footer-stat">
            <span className="stat-icon">▲</span>
            <span className="stat-text">CONTINUOUS_LEARNING</span>
          </div>
          <div className="footer-stat">
            <span className="stat-icon">●</span>
            <span className="stat-text">ACTIVE_DEVELOPMENT</span>
          </div>
          <div className="footer-stat">
            <span className="stat-icon">■</span>
            <span className="stat-text">PRODUCTION_READY</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
